<template>
  <onboarding-identity-step-layout>
    <template v-slot:content>
      <asset-v3
        class="step--icon"
        dir="abstract"
        name="onboarding-documents.svg"
      />
      <p class="body-regular gray-900">
        Envie a foto do seu <b>RG</b> ou <b>CNH</b>.
      </p>
      <p class="body-regular gray-900 mt-8">
        Com a <b>CNH</b> o processo é mais rápido.
      </p>
    </template>

    <template v-slot:footer>
      <round-button
        color="primary mt-12"
        @click="handleNextDocumentStep"
        content="Continuar"
      />
      <security-warning class="mt-12 pb-12 hide-on-large" />
      <security-warning class="pb-32 only-on-large" />
    </template>
  </onboarding-identity-step-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AssetV3 from '@/components/common/AssetV3.vue';
import RoundButton from '../../paymentLink/components/RoundButton.vue';
import OnboardingIdentityStepLayout from '../components/OnboardingIdentityStepLayout.vue';
import SecurityWarning from '../../paymentLink/components/SecurityWarning.vue';

export default {
  name: 'v2-onboarding-documents',
  components: {
    AssetV3,
    RoundButton,
    OnboardingIdentityStepLayout,
    SecurityWarning,
  },
  computed: {
    ...mapState('onboardingV2', ['routeParams']),
  },
  methods: {
    ...mapActions('onboardingV2', ['setAllowToOpenCamera']),
    async handleNextDocumentStep() {
      const { documentStep } = this.routeParams;
      this.setAllowToOpenCamera({ allow: true });
      await this.$router.replace({
        name: 'v2-onboarding-documents-camera',
        params: { documentStep },
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" style="scoped">
  @import '../../../scss/__new-styles.scss';

  .onboarding--container__documents {
    padding: 0px 24px 0 24px;
    display: grid;
    grid-template-rows: 150px 3fr 80px;
    grid-template-columns: 1fr;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    min-height: 100vh;
  }

  .onboarding--header {
    .prclx-logo {
      display: flex;
      padding-top: 16px;
      justify-content: center;
    }

    .step--bar {
      padding-top: 24px;
      padding-bottom: 0px;
      margin-bottom: 20px;
    }
  }

  .onboarding--content {
    .step--icon {
      margin-bottom: 12px;
      margin-top: 24px;
    }
  }
</style>
